import { Icons } from "@/components/ui/icons";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import * as LucideIcons from "lucide-react";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// 개발 환경에서만 console.log를 출력하는 함수
export const devLog = (...args) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
};

// 개발 환경에서만 console.error를 출력하는 함수
export const devError = (...args) => {
  if (process.env.NODE_ENV === 'development') {
    console.error(...args);
  }
};

// 개발 환경에서만 console.warn을 출력하는 함수
export const devWarn = (...args) => {
  if (process.env.NODE_ENV === 'development') {
    console.warn(...args);
  }
};

export function formatDateTime(value) {
  if (!value) return "-";
  try {
    let date;

    // Java LocalDateTime 배열 형식 [2025, 11, 17, 9, 52, 34, 465010000] 처리
    if (Array.isArray(value)) {
      const [year, month, day, hours = 0, minutes = 0, seconds = 0] = value;
      date = new Date(year, month - 1, day, hours, minutes, seconds); // month는 0-based
    } else {
      date = new Date(value);
    }

    if (isNaN(date.getTime())) return value;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } catch {
    return value || "-";
  }
}

export function formatDate(value) {
  if (!value) return "-";
  try {
    let date;

    // Java LocalDateTime 배열 형식 [2025, 11, 17, 9, 52, 34, 465010000] 처리
    if (Array.isArray(value)) {
      const [year, month, day, hours = 0, minutes = 0, seconds = 0] = value;
      date = new Date(year, month - 1, day, hours, minutes, seconds); // month는 0-based
    } else {
      date = new Date(value);
    }

    if (isNaN(date.getTime())) return value;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  } catch {
    return value || "-";
  }
}

export function getIconComponent(icon) {
  return Icons[icon] || LucideIcons[icon] || Icons.logo;
}
